import dayjs from 'dayjs';
import localizedFormat from 'dayjs/plugin/localizedFormat';
import localeData from 'dayjs/plugin/localeData';
import utc from 'dayjs/plugin/utc';
import timezone from 'dayjs/plugin/timezone';
import advancedFormat from 'dayjs/plugin/advancedFormat';
import updateLocale from 'dayjs/plugin/updateLocale';
import { Dayjs } from 'dayjs';

import 'dayjs/locale/en'; // Import English locale as an example
import 'dayjs/locale/en-au'; // Import English (Australia) locale as an example
import 'dayjs/locale/en-gb'; // Import English (Great Britain) locale as an example

dayjs.extend(advancedFormat);
dayjs.extend(localizedFormat);
dayjs.extend(localeData);
dayjs.extend(utc);
dayjs.extend(timezone);
dayjs.extend(updateLocale);

// Function to get the browser's locale and set it in dayjs
export const setDayjsLocale = (): void => {
  const browserLocale = navigator.language || 'en';
  const supportedLocales = ['en', 'en-gb', 'en-au'];
  const locale = supportedLocales.includes(browserLocale) ? browserLocale : 'en';
  dayjs.locale(locale);
};

dayjs.updateLocale('en-au', {
  ordinal: (n: number) => {
    const s = ['th', 'st', 'nd', 'rd'];
    const v = n % 100;
    return `[${n}${s[(v - 20) % 10] || s[v] || s[0]}]`;
  },
});

export type { Dayjs };

export default dayjs;
